import { type User } from '@kalos/kalos-rpc';

import { useBatchUserQuery } from '../../../../hooks/react-query/useUserQuery';
import { QueryComboboxPicker, type QueryComboboxPickerProps } from './QueryPickerV2';
import { renderUser, techniciansUserFilter } from './utils';

type TechniciansComboboxPickerProps = Omit<
  QueryComboboxPickerProps<User, Parameters<typeof useBatchUserQuery>['0']>,
  'query' | 'queryArgs' | 'renderItem'
> &
  Partial<
    Pick<QueryComboboxPickerProps<User, Parameters<typeof useBatchUserQuery>['0']>, 'renderItem'>
  > & {
    className?: string;
    contentClassName?: string;
  };

export const TechniciansComboboxPicker = (props: TechniciansComboboxPickerProps) => {
  const { className, contentClassName, ...restProps } = props;

  return (
    <QueryComboboxPicker
      // eslint-disable-next-line react-compiler/react-compiler
      query={useBatchUserQuery}
      queryArgs={{
        filters: techniciansUserFilter,
      }}
      triggerClassName={className}
      contentClassName={contentClassName}
      {...restProps}
      renderItem={props.renderItem ?? renderUser}
    />
  );
};
